/**
 * Der Zwei-Klick-Widerruf, bewusst ohne DOM (Vorlage: revoke-state.ts der Kaufland-App).
 *
 * Erster Klick schaerft nur, der zweite Klick auf DENSELBEN Eintrag loest aus. Ein
 * Klick auf einen ANDEREN Eintrag entschaerft den ersten und schaerft den neuen,
 * er loest nie den alten aus. Keine Browser-Dialoge (Projektregel).
 *
 * Vertrag: Bei JEDEM Neuladen der Liste `syncRevokeState` aufrufen. Sonst zeigt die
 * Beschriftung nach einem Reload wieder "Widerrufen", obwohl intern noch scharf ist,
 * und der naechste Klick widerruft sofort.
 */

export interface RevokeState {
  /** Eintrag, der beim naechsten Druck wirklich widerrufen wird. Null = keiner scharf. */
  armedId: string | null;
}

export type RevokeAction = 'none' | 'revoke';

export interface RevokePressResult {
  state: RevokeState;
  action: RevokeAction;
  id?: string;
}

export function createRevokeState(): RevokeState {
  return { armedId: null };
}

export function pressRevoke(s: RevokeState, id: string): RevokePressResult {
  if (s.armedId === id) return { state: s, action: 'revoke', id };
  return { state: { armedId: id }, action: 'none' };
}

/**
 * Entschaerft, wenn der scharfe Eintrag aus der Liste verschwunden oder
 * zwischenzeitlich widerrufen ist. Ist er unveraendert da, bleibt der Zustand.
 */
export function syncRevokeState(
  state: RevokeState,
  rows: ReadonlyArray<{ id: string; revoked_at?: string | null }>,
): RevokeState {
  if (state.armedId === null) return state;
  const row = rows.find((r) => r.id === state.armedId);
  const nochGueltig = row !== undefined && (row.revoked_at ?? null) === null;
  return nochGueltig ? state : { armedId: null };
}

export function revokeLabel(
  s: RevokeState,
  id: string,
  texte: { normal: string; scharf: string } = { normal: 'Widerrufen', scharf: 'Wirklich widerrufen?' },
): string {
  return s.armedId === id ? texte.scharf : texte.normal;
}
